/**
 * Normalize URL path string
 *
 * @param {String} path URL path
 *
 * @returns normalized path
 */
export default function normalizePath(path) {
  if (typeof path !== 'string') {
    return ''
  }

  path = '/' + path

  return path.replace(/\/+/g, '/').replace(/(\w+)\/$/, '$1')
}
